// Vertical labels; brand uses a single navy anchor with plum accents (Brand Guide v1)
export const VERTICALS = {
  marketing: { color: "#0B1B34", label: "Marketing AI" },
  supply_chain: { color: "#0B1B34", label: "Supply Chain AI" },
  it_tech: { color: "#0B1B34", label: "IT Transformation" },
  education: { color: "#0B1B34", label: "Learning AI" },
  default: { color: "#0B1B34", label: "Perspective" },
};

export const NANO_GOLD = "#FFD700";

// Map a free-text category string to an accent.
export function accentFor(category = "") {
  const c = category.toLowerCase();
  if (c.includes("supply")) return VERTICALS.supply_chain;
  if (c.includes("market")) return VERTICALS.marketing;
  if (c.includes("it") || c.includes("tech") || c.includes("platform") || c.includes("infrastructure")) return VERTICALS.it_tech;
  if (c.includes("learn") || c.includes("educat") || c.includes("capab") || c.includes("skill")) return VERTICALS.education;
  return VERTICALS.default;
}
